import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const SESSION_KEY = "hitsstube-intro-seen";

export default function Intro({ onDone }) {
  const [phase, setPhase] = useState("idle"); // idle | ball | word | out | done
  const startedRef = useRef(false);

  useEffect(() => {
    // Guard gegen StrictMode-Doppelaufruf: Entscheidung nur einmal treffen.
    if (startedRef.current) return;
    startedRef.current = true;

    // ?intro=1 erzwingt das Intro (Abnahme/Test), ?intro=0 ueberspringt es.
    const forced = new URLSearchParams(window.location.search).get("intro");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let seen = false;
    try {
      seen = sessionStorage.getItem(SESSION_KEY) === "1";
    } catch (e) {
      seen = true;
    }
    if (reduced || forced === "0" || (forced !== "1" && seen)) {
      setPhase("done");
      onDone();
      return;
    }
    if (forced !== "1") {
      try {
        sessionStorage.setItem(SESSION_KEY, "1");
      } catch (e) {}
    }
    document.documentElement.classList.add("intro-lock");
    setPhase("ball");
    const t1 = setTimeout(() => setPhase("word"), 900);
    const t2 = setTimeout(() => {
      setPhase("out");
      onDone();
    }, 1500);
    const t3 = setTimeout(() => {
      setPhase("done");
      document.documentElement.classList.remove("intro-lock");
    }, 1900);
    // Kein Cleanup, das die Timer abbricht: StrictMode wuerde sonst den
    // Ablauf nach dem ersten Durchlauf stoppen. Bei echtem Unmount bleibt
    // nur der intro-lock bis t3 – das Fenster ist 1,9 s gross.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (phase === "idle" || phase === "done") return null;

  return (
    <div
      data-testid="intro-loading-screen"
      aria-hidden="true"
      className={`fixed inset-0 z-[100] flex items-center justify-center overflow-hidden transition-opacity duration-300 ${
        phase === "out" ? "opacity-0" : "opacity-100"
      }`}
      style={{ background: "var(--paper)" }}
    >
      {(phase === "ball" || phase === "word") && (
        <motion.img
          src="/images/Hitstube_Discokugel.webp?v=2"
          alt=""
          draggable="false"
          width={1361}
          height={1155}
          className="w-32 sm:w-40"
          initial={{ opacity: 0, scale: 0.92, rotate: 0 }}
          animate={
            phase === "ball"
              ? { opacity: 1, scale: 1, rotate: 360 }
              : { opacity: 0, scale: 1.06, rotate: 420 }
          }
          transition={
            phase === "ball"
              ? { rotate: { duration: 0.9, ease: "linear" }, opacity: { duration: 0.25 }, scale: { duration: 0.3 } }
              : { duration: 0.25, ease: "easeIn" }
          }
        />
      )}

      {phase === "word" && (
        <>
          {Array.from({ length: 12 }).map((_, i) => (
            <motion.span
              key={i}
              className="absolute left-1/2 top-1/2 h-2.5 w-2"
              style={{ background: "var(--red)" }}
              initial={{ x: 0, y: 0, opacity: 0, rotate: 0 }}
              animate={{
                x: (i - 5.5) * 36,
                y: -70 - (i % 4) * 46,
                opacity: [0, 1, 0],
                rotate: i * 42,
              }}
              transition={{ duration: 0.6, delay: 0.04, ease: "easeOut" }}
            />
          ))}
          <motion.span
            className="font-display text-[clamp(2.1rem,8.5vw,4.5rem)] leading-none tracking-tight text-brand-red"
            initial={{ opacity: 0, scale: 0.72, y: 16 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ type: "spring", stiffness: 280, damping: 22, delay: 0.08 }}
          >
            HITSSTUBE
          </motion.span>
        </>
      )}
    </div>
  );
}
